import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import image from 'assets/custom-svg.png';
import { useTheme } from '@mui/material/styles';
import { generateTestId, reactParserCommonOptions } from '../../../app/functions';
import HtmlContent from 'components/html/HtmlContent';


const Card = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: 'transparent',
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: `url(${image})`,
  backgroundPosition: 'center',
  width: '165px',
  height: '146px',
  [theme.breakpoints.up('sm')]: {
    width: '180px',
    height: '155px',
  },
  [theme.breakpoints.up('md')]: {
    width: '165px',
    height: '155px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '165px',
    height: '170px',
  },
  [theme.breakpoints.up('xl')]: {
    backgroundSize: '120%',
    width: '250px',
    height: '210px',
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '3px',
  left: '0px',
  width: '39.615px',
  height: '39.615px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '69.23px',
  backgroundColor: theme.palette.common.white,
  boxShadow: '0px 4.62px 69.23px rgba(45, 85, 199, 0.08)',
  top: '0px',
  left: '1px',
  '& img': {
    width: '21.615px',
    height: '22px',
  },
  [theme.breakpoints.up('sm')]: {
    width: '40px',
    height: '40px',
    top: '0px',
    left: '10px',
    borderRadius: '69.23px',
    '& img': {
      width: '26px',
      height: '26px',
    },
  },
  [theme.breakpoints.up('md')]: {
    width: '45px',
    height: '45px',
    top: '0px',
    left: '-2px',
    '& img': {
      width: '25px',
      height: '25px',
    },
  },
  [theme.breakpoints.up('lg')]: {
    width: '40px',
    height: '40px',
    top: '12px',
    left: '2px',
    '& img': {
      width: '25px',
      height: '25px',
    },
  },
  [theme.breakpoints.up('xl')]: {
    width: '55px',
    height: '55px',
    top: '0px',
    left: '15px',
    '& img': {
      width: '28px',
      height: '28px',
    },
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'center',
  marginTop: '50px',
  marginLeft: '20px',
  textAlign: 'right',
  direction: 'rtl',
  boxSizing: 'border-box',
  [theme.breakpoints.up('sm')]: {
    marginLeft: '15px',
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '60px',
  },  
  [theme.breakpoints.up('xl')]: {
    marginTop: '70px',
    marginLeft: '35px',
  },
}));

const CustomTypography = styled(Typography)(({ theme, variant }) => ({
  color: theme.palette.serviceCard.text,
  fontSize: variant === 'title' ? '12px' : '12px',
  fontWeight: variant === 'title' ? 700 : 400,
  lineHeight: '1.25em',
  textAlign: 'left',
  marginTop: variant === 'title' ? '8px' : '0',
  marginBottom: variant === 'title' ? '4px' : '0',
  whiteSpace: variant === 'title' ? 'nowrap' : 'normal',
  maxWidth: 'calc(100% - 20px)',
  [theme.breakpoints.up('sm')]: {
    whiteSpace: 'normal',
    fontSize: variant === 'title' ? '14px' : '12px',
    maxWidth: 'calc(100% - 30px)',
    // marginLeft: '10px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: variant === 'title' ? '14px' : '12px',
    maxWidth: 'calc(100% - 15px)',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: variant === 'title' ? '14px' : '12px',
    maxWidth: 'calc(100% - 30px)',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: variant === 'title' ? '18px' : '16px',
    maxWidth: 'calc(100% - 40px)',
  },
}));

const ServiceCard = ({ title, description, icon, testid }) => {
  const theme = useTheme();
  
  return (
    <Card testid="service-card-service-card-customer-join">
      <IconContainer testid={generateTestId(testid, 'iconContainer')}>
        <img src={icon} alt={title} testid={generateTestId(testid, 'service_icon')} />
      </IconContainer>
      <ContentContainer testid={generateTestId(testid, 'contentContainer')}>
        <CustomTypography
          variant="title"
          testid={generateTestId(testid, 'serviceHeader')}
        >
          {title}
        </CustomTypography>
        <CustomTypography
          component="div"
          testid={generateTestId(testid, "serviceDescription")}
        >
          <HtmlContent content={description} />
        </CustomTypography>
      </ContentContainer>
    </Card>
  );
};

export default ServiceCard; 
